import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'onboarding',
    component: () => import('@/pages/Onboarding.vue'),
    meta: {
      layout: 'DefaultLayout'
    }
  },
  {
    path: '/forms',
    name: 'onboarding-forms',
    component: () => import('@/pages/Forms.vue'),
    meta: {
      layout: 'DefaultLayout'
    }
  },
  // {
  //   path: '/family',
  //   component: Family,
  //   meta: { requiresAuth: true }
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Example navigation guard for protected routes
router.beforeEach(async (to, from, next) => {
  try {
    let layout = to.meta.layout
    let layoutComponent = await import(`@/layouts/${layout}.vue`)
    to.meta.layoutComponent = layoutComponent.default
  } catch (e) {
    let layout = 'DefaultLayout'
    let layoutComponent = await import(`@/layouts/${layout}.vue`)
    to.meta.layoutComponent = layoutComponent.default
  }

  const isAuthenticated = true; // Replace with your auth logic
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/'); // Redirect to login if not authenticated
  } else {
    next();
  }
});

export default router;
